import React from 'react'

import Page from '../../../components/pdf/Page'
import Content from './_shared/Content'

const PdfDocument = ({ templateId }) => {
  return (
    <Page>
      <Content templateId={templateId} />
    </Page>
  )
}

export default PdfDocument
